import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import UserMenu from './UserMenu';
import Alert from './Alert';
import axios from 'axios';
import Tools from './Tools';

const CreateExecutives = (props) => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [data, setData] = useState({});

    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        });
    }

    const checkExtensionNotUsed = async (e) => {
        const value = e.target.value;
        if(value.length > 0){
            setLoading(true);
            try {
                const res = await axios.get(`${process.env.REACT_APP_URI_API_CRM}/extension/check/${value}`);
                if (res.data.exist) { 
                    setError(`El anexo ${value} ya está en uso`);
                } else {
                    setError(false);
                }
            } catch (err) {
                setError('Error al verificar el anexo');
            }
            setLoading(false);
        }
    }

    const checkMailNotUsed = async (e) => {
        const value = e.target.value;
        if (value.length > 0) {
            setLoading(true);
            try {
                const res = await axios.get(`${process.env.REACT_APP_URI_API_CRM}/email/check/${value}`);
                if (res.data.exist) { 
                    setError(`El email ${value} ya está en uso`);
                } else {
                    setError(false);
                }
            } catch (err) {
                setError('Error al verificar el email');
            }
            setLoading(false);
        }
    }

    const CreateExecutive = async () => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

        if(!data.executiveName || !data.email || !data.extension || !data.rut){
            setError('Todos los campos son obligatorios');
            return;
        }
        setLoading(true);
        try {
            const res = await axios.post(`${process.env.REACT_APP_URI_API_CRM}/executives`, data, { headers: { 'Authorization': currentSessionData.token } });

            if (res.status === 200) {
                alert('Ejecutivo creado correctamente');
                setError(false);
                setData({});

            } else {
                setError(res.data.error || 'Error al crear el ejecutivo');
            }
        } catch (err) {
            console.error(err);
            setError('Error al crear el ejecutivo');
        }
        setLoading(false);
    }
   
    useEffect(() => {
    }, []);

    
    

    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} current="10" softphoneConnectionStatus={props.softphoneConnectionStatus} />
            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1 className={loading ? 'loading' : ''}>Crear Ejecutivos</h1>
                        <span class="upper">Administración</span>
                    </div>
                    <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues} />
                </div>

                <div className="flexRow">
                    <div className="flexCol">
                        <div className="inputWrapper x3">
                            <label className="required">Ejecutivo Nombre</label>
                            <input type="text" name="executiveName" value={data.executiveName || ''} onChange={handleChange} placeholder="Nombre del ejecutivo" />
                        </div>
                    </div>
                    <div className="flexCol">
                        <div className="inputWrapper x3">
                            <label className="required">Email</label>
                            <input type="text" name="email" value={data.email || ''} onChange={handleChange} placeholder="Email del ejecutivo" onBlur={checkMailNotUsed} />
                        </div>

                    </div>
                    <div className="flexCol">
                        <div className={`inputWrapper ${loading ? 'loading' : ''}`}>
                            <label className="required">Anexo</label>
                            <input type="text" name="extension" value={data.extension || ''} onChange={handleChange} placeholder="Anexo" onBlur={checkExtensionNotUsed}/>
                        </div>

                    </div>
                    <div className="flexCol">
                        <div className="inputWrapper x2">
                            <label className="required">Rut/DNI/Identificador</label>
                            <input type="text" name="rut" value={data.rut || ''} onChange={handleChange} placeholder="Identificador" />
                        </div>

                        <button className={loading ? 'default collapsed loading' : 'default collapsed'} onClick={CreateExecutive}>Crear Ejecutivo</button> 
                    </div>
                </div>

                

                {error ? (
                    <Alert className="error mgb20">Error: {error}</Alert>
                ) : null}
            </div>
        </div>
    );

}

export default CreateExecutives;
